import { render, staticRenderFns } from "./clinicMenu.vue?vue&type=template&id=6f9ec1fa"
import script from "./clinicMenu.vue?vue&type=script&lang=js"
export * from "./clinicMenu.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports

/* nuxt-component-imports */
installComponents(component, {SingleSelect: require('/vercel/path0/components/ui/singleSelect.vue').default})
